import { format, subDays, startOfDay, endOfDay } from 'date-fns';

export const formatDate = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

export const formatDateTime = (date: Date): string => {
  return format(date, 'yyyy-MM-dd HH:mm:ss');
};

export const formatDateTimeISO = (date: Date): string => {
  return date.toISOString();
};

export interface DateRange {
  start: string;
  end: string;
}

export const getDateRangePreset = (preset: string): DateRange => {
  const now = new Date();
  const endDate = endOfDay(now);

  switch (preset) {
    case 'last_24h':
      return {
        start: formatDateTime(subDays(now, 1)),
        end: formatDateTime(endDate),
      };
    case 'last_7d':
      return {
        start: formatDate(subDays(now, 7)),
        end: formatDate(endDate),
      };
    case 'last_30d':
      return {
        start: formatDate(subDays(now, 30)),
        end: formatDate(endDate),
      };
    case 'today':
      return {
        start: formatDate(startOfDay(now)),
        end: formatDate(endDate),
      };
    default:
      return {
        start: formatDate(subDays(now, 7)),
        end: formatDate(endDate),
      };
  }
};

export const getYearMonthDay = (date: Date): { year: number; month: number; day: number } => {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};

